export var BrandStatusEnum;
(function (BrandStatusEnum) {
    BrandStatusEnum["NeedsReview"] = "NEEDS_REVIEW";
    BrandStatusEnum["Approved"] = "APPROVED";
    BrandStatusEnum["Suspect"] = "SUSPECT";
    BrandStatusEnum["Locked"] = "LOCKED";
    BrandStatusEnum["Reported"] = "REPORTED";
    BrandStatusEnum["Undetermined"] = "UNDETERMINED"; // same as NEEDS_REVIEW
})(BrandStatusEnum || (BrandStatusEnum = {}));
export const BrandStatuses = [
    { label: 'NEEDS_REVIEW', value: BrandStatusEnum.NeedsReview },
    { label: 'UNDETERMINED', value: BrandStatusEnum.Undetermined }, // same as NEEDS_REVIEW
    { label: 'APPROVED', value: BrandStatusEnum.Approved },
    { label: 'SUSPECT', value: BrandStatusEnum.Suspect },
    { label: 'LOCKED', value: BrandStatusEnum.Locked },
    { label: 'REPORTED', value: BrandStatusEnum.Reported }
];
export const getBrandStatusDisplay = (status) => {
    switch (status) {
        case BrandStatusEnum.NeedsReview:
            return 'Needs Review';
        case BrandStatusEnum.Approved:
            return 'Approved';
        case BrandStatusEnum.Suspect:
            return 'Suspect';
        case BrandStatusEnum.Locked:
            return 'Locked';
        case BrandStatusEnum.Reported:
            return 'Reported';
        case BrandStatusEnum.Undetermined:
            return 'Undetermined';
        default:
            return 'Unknown Status';
    }
};
